/**
 * ./src/landing/MainBody.js
 * 
 * This component serves as the main content area of the landing page.
 * It displays the user's progress stats, such as reading speed, focus time, 
 * and reading comprehension, along with improvement trends.
 */


import React, { useEffect, useState } from 'react';
import LeftBody from './LeftBody';
import './MainBody.css';
import progress1 from "./icons/progress1.svg";
import progress2 from "./icons/progress2.svg";
import progress3 from "./icons/progress3.svg";
import { useNavigate } from 'react-router-dom';  // Import useNavigate
import { API_BASE_URL } from "../config";

// TO DO display the excercises correctly from backend 

const MainBody = () => {
  const [userData, setUserData] = useState(null); // Store user progress
  const [showRightBody, setShowRightBody] = useState([false, false, false]); // Track appearance of each part of right body
  const [showButton, setShowButton] = useState(false); // Track button appearance
  const [currentFlagCircleIndex, setCurrentFlagCircleIndex] = useState(0); // New state to track current flag circle index
  const navigate = useNavigate();  // Initialize useNavigate hook

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/user/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        });

        console.log("Raw Response:", response);
        const data = await response.json();
        console.log('data', data);
        setUserData(data);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const isExerciseUnlocked = () => {
    if (!userData) return false; // If user data isn't loaded yet, assume locked
    return userData.exercisesUnlocked[currentFlagCircleIndex] >= 0;
  };

  // Function to trigger when the flag appears
  const handleFlagAppear = (circleNumber) => {
    console.log("Circle Number:", circleNumber); // Debugging line
    const sectionDelay = 500; // Delay between each section in the right body

    // Start showing the sections in sequence shortly after the flag appears
    setTimeout(() => {
      setShowRightBody((prevState) => [true, ...prevState.slice(1)]); // Show the first part
    }, sectionDelay);

    setTimeout(() => {
      setShowRightBody((prevState) => [true, true, ...prevState.slice(2)]); // Show the second part
    }, 2 * sectionDelay);

    setTimeout(() => {
      setShowRightBody([true, true, true]); // Show the third part
    }, 3 * sectionDelay);

    // Show the button after all sections appear
    setTimeout(() => {
      setShowButton(true); // Show the button
    }, 4 * sectionDelay);
  };

  // Function to handle the button click and navigate to the dashboard
  // const handleStartClick = () => {
  //   const exerciseNumber = currentFlagCircleIndex + 1; // Calculate exercise number

  //   navigate(`/exercise${exerciseNumber}`); // Navigate to the dynamic exercise page
  // };

  const handleStartClick = () => {
    // Define a mapping of currentFlagCircleIndex to exerciseNumber
    const exerciseMapping = {
      0: 1,
      1: 2,
      2: 3,
      3: 4,
      4: 5,
      5: 7,  // Skipping 6
      6: 9,  // Skipping 8
      7: 10  // Exercise 10
    };
  
    // Get the correct exerciseNumber based on the current index
    const exerciseNumber = exerciseMapping[currentFlagCircleIndex] || 1; // Default to 1 if undefined
  
    // Navigate to the correct exercise page
    navigate(`/exercise${exerciseNumber}`);
  };

  return (
    <div className="main-body">
      <div className="main-text">
        <h1>Welcome Back!</h1>
      </div>

      <div className="main-content">
        <LeftBody 
          onFlagAppear={handleFlagAppear} 
          onCircleChange={setCurrentFlagCircleIndex} // Pass handler to update currentFlagCircleIndex
        /> {/* Left body with roadmap and animation */}

        <div className="right-body">
          {/* First stat-item (Reading Speed) */}
          <div className={`stat-item ${showRightBody[0] ? 'visible' : ''}`}>
            <div className="stat-text">
              <p>Reading Speed</p>
              <strong>200 wpm → 800 wpm</strong>
            </div>
            <img src={progress1} alt="Progress 1" className="progress-image" />
          </div>

          {/* Second stat-item (Focus Time) */}
          <div className={`stat-item ${showRightBody[1] ? 'visible' : ''}`}>
            <div className="stat-text">
              <p>Focus Time</p>
              <strong>1 min → 15 min</strong>
            </div>
            <img src={progress2} alt="Progress 2" className="progress-image" />
          </div>

          {/* Third stat-item (Reading Comprehension) */}
          <div className={`stat-item ${showRightBody[2] ? 'visible' : ''}`}>
            <div className="stat-text">
              <p>Reading Comprehension</p>
              <strong>65% → 95% accuracy</strong>
            </div>
            <img src={progress3} alt="Progress 3" className="progress-image" />
          </div>

          {/* Button appears after the last section */}
          <button 
            className={`landing-start-button ${showButton ? 'fade-in' : ''}`} 
            onClick={handleStartClick}  
            disabled={!isExerciseUnlocked()} 
            style={{
              cursor: isExerciseUnlocked() ? "pointer" : "not-allowed"
            }}
          >
            {isExerciseUnlocked() ? `Start Exercise ${currentFlagCircleIndex+1}!` : "Locked"}
          </button>
        </div>
      </div>   
    </div>
  );
};

export default MainBody;